export enum VolumesDatabaseType {
  ModelMixSpecs = 'X',
  ModelMix = 'M',
  SourceData = 'V',
}
